 export function burialPoint(params,url,method = 'GET') {
    // 访问标识（登录和非登录都有）
    if(sessionStorage.getItem('sessionId')) {
      params.sessionId = sessionStorage.getItem('sessionId')
    }else {
      const sessionId = Math.random().toString(16).slice(2);
      sessionStorage.setItem('sessionId', sessionId)
      params.sessionId =sessionId
    }

    return new Promise((resolve,reject) =>{
        const xhr = new XMLHttpRequest()
        xhr.open(method.toUpperCase(), url)
        if(method.toUpperCase() === 'POST') {
            xhr.setRequestHeader('content-type', 'application/json;charset=utf-8');
        }
        xhr.onreadystatechange = () =>{
            if(xhr.readyState === 4 ) {
              if(xhr.status === 200) {
                resolve(xhr.responseText)
              }else {
                reject(xhr.statusText)
              }
            }
        }
        xhr.onerror = () => {
            reject(xhr.statusText)
        }
    let beforeUnload_time = 0, unload_time = 0;
 // 添加beforeunload事件
    window.addEventListener('beforeunload', function(e) {
      beforeUnload_time = new Date().getTime()
    });
    // window.addEventListener('load',function() {
    //   params.url = (unload_time-beforeUnload_time) <= 1 ? '/endTR' : '/reloadTR'
    //   const blob = new Blob([ JSON.stringify(params) ], {
    //     type: 'application/json; charset=UTF-8',
    //   })
    //     navigator.sendBeacon('http://www.eiiplat.com/api/pt/arms', blob)
    // })
    window.addEventListener('unload',() =>{
      unload_time = new Date().getTime();
      params.url = '/endTR'
      if((unload_time-beforeUnload_time) <= 3) {
        const blob = new Blob([ JSON.stringify(params) ], {
          type: 'application/json; charset=UTF-8',
        })
        navigator.sendBeacon('api/pt/arms', blob) // 正式
        // navigator.sendBeacon('http://47.96.70.127:88/api/pt/arms', blob) // 测试
      }
    })
    xhr.send(method.toUpperCase() === 'GET' ? null : JSON.stringify(params));
  });

}



// WEBPACK FOOTER //
// ./src/utils/BurialPoint.js